module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-shizuoka-1-27833584fd14f27f305cf8e32dc8f82a.png";